
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { VueFinalModal } from 'vue-final-modal';

import Image from '@hems/component/src/image/Image.vue';
import { useLoading } from '@hems/util/src/composable/loading';
import type { MobileModalType } from '@hems/util/src/constant/modal';
import { MOBILE_MODAL_TYPE } from '@hems/util/src/constant/modal';

export default defineComponent({
  name: 'MobileModal',
  components: { VueFinalModal, Image },
  props: {
    type: {
      type: String as PropType<MobileModalType>,
      default: MOBILE_MODAL_TYPE.ALERT,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    confirmButtonText: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: String,
      default: '',
    },
    isReversed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['confirm', 'close'],
  setup(props, { emit }) {
    const { resetLoading } = useLoading();

    resetLoading();

    const onClose = (close: () => void) => {
      emit('close');

      close();
    };

    const onConfirm = (close: () => void) => {
      emit('confirm');

      close();
    };

    const setupAutoClose = (close: () => void) => {
      if (props.type === MOBILE_MODAL_TYPE.ALERT) {
        setTimeout(() => {
          onClose(close);
        }, 1000);
      }

      return true;
    };

    const isAlertModal = computed(() => props.type === MOBILE_MODAL_TYPE.ALERT);

    const isWarningModal = computed(() => props.type === MOBILE_MODAL_TYPE.WARN);

    const isConfirmModal = computed(() => props.type === MOBILE_MODAL_TYPE.CONFIRM);

    return {
      onClose,
      isAlertModal,
      setupAutoClose,
      onConfirm,
      isWarningModal,
      isConfirmModal,
      MOBILE_MODAL_TYPE,
    };
  },
});
